export default {
  test: "test",
  common: {
    message: {
      created: "作成しました",
      updated: "更新しました",
      deleted: "削除しました",
      no_result: "該当データは見つかりませんでした",
      no_more: "データはもうありません",
      errors: {
        image: "5MB以内の画像をアップロードしてください",
      },
    },
    modal: {
      cancel_content:
        "変更内容を破棄して編集を終了します。この操作は取り消せません。",
      delete_content: "削除を実行します。この操作は取り消せません。",
    },
    buttons: {
      cancel: "キャンセル",
      yes: "はい",
      no: "いいえ",
    },
  },
  post_group: {
    have_used_cannot_delete: "This post group have used, so it cannot delete",
    confirm_delete: "Do you want delete this post group",
    confirm_cancel:
      "Do you reset post group just additional after close this modal",
  },
};
